import type { ExceptionField } from '@/api/cockpit';

export function isMatchedHeaderField(field: ExceptionField): boolean {
  return (
    field.matchedValue !== undefined ||
    field.matchedDisplayValue !== undefined ||
    Array.isArray(field.matchedOptions) ||
    Array.isArray(field.matchedCandidates)
  );
}
